export default __webpack_public_path__ + "static/media/two-sample.dc9b6b21.svg";